import clsMainLogo from './cls-main.svg';
import clsClothingLogo from './cls-clothing.svg';
import abcMainLogo from './abc-main.svg';
import overallMainLogo from './overall-main.svg';
import overallWordmark from './overall-wordmark.svg';

/**
 * Brand logotypes keyed by brand → sub-brand.
 * Shared by the DS Header and the DS Preloader (`variant="logo"`).
 */
const BRAND_LOGOS = {
  CLS: {
    main: clsMainLogo,
    clothing: clsClothingLogo,
  },
  ABC: {
    main: abcMainLogo,
    clothing: abcMainLogo,
  },
  // Figma custom/32/ovr-logotype (OVER/LL + STUDIOS) — no separate clothing mark;
  // `wordmark` = the large OVER/LL mark of Footer/Overall (2497:94227, 411×64)
  Overall: {
    main: overallMainLogo,
    clothing: overallMainLogo,
    wordmark: overallWordmark,
  },
};

export default BRAND_LOGOS;
